// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"f73af097","161":"9906437f","505":"fb20e3f4","589":"5be64e73","714":"f060bc79","777":"fcd78aca"}[chunkId] + ".css";
};